export default {
    namespaced: true,
    state: {
        competitorList: [],
    },
    getters: {
        COMPETITOR_LIST: state => {
            return state.competitorList;
        },
    },
    mutations: {
        COMPETITOR_LIST: (state, payload) => {
            return state.competitorList = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/competitors/list',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.competitorList = responseData.competitorList
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/competitors/list',
                parameter: state.competitorList,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.competitorList = responseData.competitorList
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                }
            });
        },
    }
}